import classNames from 'classnames';
import { useLayoutEffect, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { useLeftNavigationContext } from './left_navigation_context';
const containerCss = "c1obg0me";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const PortalLeftNavigation = ({
  children
}) => {
  const {
    setPortalRendered,
    portalRef,
    refBound
  } = useLeftNavigationContext();
  useLayoutEffect(() => {
    setPortalRendered(true);
    return () => {
      setPortalRendered(false);
    };
  }, [setPortalRendered]);
  if (!refBound) {
    return null;
  }
  return createPortal(<Container>
      {children}
    </Container>, portalRef.current);
};

require("./portal_left_navigation.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./portal_left_navigation.js");